import { TouchEvent, MouseEvent } from 'react';
import { ICmsLink, TImage } from '@components/typescript';

export enum ECarouselDirection {
  LEFT = 'left',
  RIGHT = 'right',
}

export type TCarouselEventHandlerSignature = {
  (e?: TouchEvent, isTouch?: boolean): void;
  (e?: MouseEvent, isTouch?: boolean): void;
};

export enum ECarouselType {
  packshot = 'packshot',
  arrangement = 'arrangement',
}

export type TCaruselSlide = {
  itemId: number;
  link: ICmsLink;
  image: TImage;
  blur?: TImage;
  title: string;
  titleColor?: string;
  colorTitle?: string;
};

export type TCarouselSlides = Array<TCaruselSlide>;
